import PropTypes from 'prop-types';

export default PropTypes.shape({
  mimeType: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});
